import { SSRSafeSuspense } from '@zep/common/react-boundary';
import S from './Footer.module.scss';
import { FooterInformation } from './FooterInformation';
import { FooterMenus } from './FooterMenus';
export const Footer = () => {
  return <footer className={S.footer} data-sentry-component="Footer" data-sentry-source-file="Footer.tsx">
      <div className={S.inner}>
        <div className={S.footer_width}>
          <div className={S.footer_logo}>
            <img width={83} height={41} src="/images/light/layout/logo_zep.svg" alt="zep" />
          </div>
          <SSRSafeSuspense data-sentry-element="SSRSafeSuspense" data-sentry-source-file="Footer.tsx">
            <FooterMenus data-sentry-element="FooterMenus" data-sentry-source-file="Footer.tsx" />
          </SSRSafeSuspense>
        </div>
        <hr />
        <SSRSafeSuspense data-sentry-element="SSRSafeSuspense" data-sentry-source-file="Footer.tsx">
          <FooterInformation data-sentry-element="FooterInformation" data-sentry-source-file="Footer.tsx" />
        </SSRSafeSuspense>
      </div>
    </footer>;
};